import MicroModal from 'micromodal';

window.addEventListener('load', () => {
    const modalContainer = $('.team-cards-modal');
    const modalContainerDir = $('.team-directors-cards-modal');

    if(modalContainer.length !==0) {
        MicroModal.init({
            onClose(modal, element, event) {
                event.preventDefault();
                event.stopPropagation();
            },
            openTrigger: 'data-micromodal-open',
            closeTrigger: 'data-micromodal-close',
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: false,
            awaitCloseAnimation: true,
            debugMode: true
        });
    }

    if(modalContainerDir.length !==0) {
        MicroModal.init({
            onClose(modal, element, event) {
                event.preventDefault();
                event.stopPropagation();
            },
            openTrigger: 'data-micromodal-dir-open',
            closeTrigger: 'data-micromodal-dir-close',
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: false,
            awaitCloseAnimation: true,
            debugMode: true
        });
    }
});
